<ng-container *ngIf="!vision">
  <div class="vision" *ngIf="!vision" (click)="visionClick()">
    <img src="../assets/imgs/akadalymentesito.png" alt="" height="40" />
  </div>
  <app-header
    scrolledHeader
    #scrolledHeaderElement="scrolledHeader"
    [headerItems]="menuItems"
    logoPlace="center"
    title="Dunaszentmikós"
    logoPath="./././assets/imgs/cimer.svg"
    [needAnimatonOnScroll]="isMainPage"
  ></app-header>
  <div class="content">
    <div class="row">
      <div class="col-lg-12 p-0">
        <router-outlet></router-outlet>
      </div>
    </div>
    <div class="row footer mt-auto">
      <div class="col-lg-12 pr-0">
        <div class="row pt-5 align-items-center">
          <div class="col-md-6 text-center">
            <img src="assets/imgs/logo.png" />
          </div>
          <div class="col-md-6 text-center">
            <p class="h4 mb-4 font-weight-bold">Partnereink</p>
            <div class="row">
              <div class="col-6">
                <a href="www.tata.hu">Tata Város Honlapja</a>
              </div>
              <div class="col-6">
                <a href="http://hilltopborhotel.hu/"
                  >Hilltop Borhotel és Étterem</a
                >
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-6">
                <a href="http://www.kosziklas.hu/">Kősziklás borászat</a>
              </div>
              <div class="col-6">
                <a href="https://www.landal.hu/parks/residence-duna/"
                  >Landal Residence Duna</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-5 pt-5">
          <div class="col-lg-12 text-center">
            © 2020 Dunaszentmiklós. All Rights Reserved.
            <a href="https://www.facebook.com/dunaszentmiklos/" class="fb-link"
              ><img src="./assets/imgs/facebook.png" alt="facebook" height="20"
            /></a>
          </div>
          <div class="col-12 dev-ref text-center mt-1">
            Fejlesztés és Design:
            <a href="http://krisztianpszota.hu" target="_blank"
              >Pszota Krisztián</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="mfp"
    [class.privacyOpen]="!hidePrivacy"
    [class.hide]="hideSzechenyi"
    routerLink="/main/competitions"
  ></div>
  <div
    class="mak"
    [class.scrolled]="scrolledHeaderElement.scrolled"
    routerLink="/main/competitions"
  ></div>
  <div
    class="szechenyi"
    [class.privacyOpen]="!hidePrivacy"
    [class.hide]="hideSzechenyi"
    routerLink="/main/competitions"
  ></div>
  <div
    class="hide-szechenyi-btn"
    [class.privacyOpen]="!hidePrivacy"
    [class.hide]="hideSzechenyi"
    (click)="hideSzechenyi = !hideSzechenyi"
  >
    <i
      class="fas"
      [class.fa-chevron-down]="!hideSzechenyi"
      [class.fa-chevron-up]="hideSzechenyi"
    ></i>
  </div>

  <div class="privacy" [class.hide]="hidePrivacy">
    <div class="row">
      <div class="col-lg-10">
        <p class="m-0">
          Kedves Látogató! Tájékoztatjuk, hogy a weboldal a felhasználói
          élmények fokozása érdekében sütiket alkalmaz. A honlap használatával a
          tájékoztatást Ön tudomásul veszi.
          <a class="link" routerLink="/privacy">Adatkezelési Tájékoztató</a>
          megtekintése
        </p>
      </div>
      <div class="col-lg-2">
        <button class="btn" (click)="hidePrivacy = true">Elfogadom</button>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="vision">
  <div class="vision-container p-4">
    <div class="row">
      <div class="col-12 h1 text-center my-3">
        Dunaszentmiklós község hivatalos honlapja vakok és gyengénlátók számára
      </div>
    </div>
    <div class="row my-3">
      <div class="col-sm-8 text-center h2 white-text">Legfrissebb hírek</div>
      <div class="col-sm-4 text-center h3 back" (click)="vision = false">
        Vissza a grafikus főoldalra
      </div>
    </div>
    <div class="row">
      <div class="col-sm-8 p-2">
        <ng-container *ngFor="let n of news">
          <div class="row news-row my-2" *ngIf="now < n.endDate">
            <div class="col-12">
              <div class="title text-center white-text h3">
                {{ n.headertext }}
              </div>
              <div
                class="description text-center white-text h3"
                *ngIf="n.body && n.body.length > 0"
                [innerHTML]="n.body"
              ></div>
              <app-gallery
                *ngIf="n.picPath"
                folder="news"
                picNum="1"
                [picPath]="n.picPath"
              ></app-gallery>
              <div class="docs" *ngIf="n.documents && n.documents.length > 0">
                <ul class="my-3 text-center p-0">
                  <li
                    class="vision-link h4"
                    *ngFor="let doc of n.documents"
                    (click)="download(doc.name, doc.ext, doc.path)"
                  >
                    {{ doc.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="col-sm-4">
        <div class="row h4 text-center">
          <div class="col-12 white-text">Menü</div>
          <div class="col-12 vision-link" routerLink="/main-council">
            Önkormányzat
          </div>
          <div class="col-12 vision-link" routerLink="/nationality-council">
            Nemzetiségi önkormányzat
          </div>
          <div class="col-12 vision-link" routerLink="/sights">Látnivalók</div>
          <div class="col-12 vision-link" routerLink="/contacts">Kapcsolat</div>
          <div class="col-12 vision-link" routerLink="/election">Választás</div>
          <div class="col-12 vision-link" routerLink="/common-datas">
            Közérdekű adatok
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
